import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { SETTINGS } from './tokens';

export function DiscardDialog({
  open,
  body,
  onKeep,
  onDiscard,
}: {
  open: boolean;
  body: string;
  onKeep: () => void;
  onDiscard: () => void;
}) {
  return (
    <Dialog
      open={open}
      onClose={onKeep}
      role="alertdialog"
      aria-labelledby="settings-discard-title"
      PaperProps={{ sx: { borderRadius: 2, maxWidth: 460, p: 1 } }}
    >
      <DialogTitle id="settings-discard-title" sx={{ fontSize: 20, fontWeight: 700, color: SETTINGS.ink, pb: 1 }}>
        Discard changes?
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 16, color: SETTINGS.muted }}>{body}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="text" onClick={onKeep}>
          Keep editing
        </Button>
        <Button variant="contained" color="error" onClick={onDiscard}>
          Discard
        </Button>
      </DialogActions>
    </Dialog>
  );
}
